import { apiGet } from "./helpers/api";

// Fetches the formatted support profile for the current user. When a course is
// in context, its current-course attributes are included. Resolves with
// `{ data, meta }` — meta carries the Crisp website id from the backend.
export function fetchSupportProfile(courseId) {
  const query = courseId ? `?course_id=${courseId}` : "";

  return apiGet(`/api/v1/support_profile${query}`).then(
    (response) => response.body
  );
}
